import LanguageService from "../../../../service/LanguageService";
import DataService from "../../../../service/DataService";
import MethodService from "../../../../service/MethodService";
import ExtensionService from "../../../../service/ExtensionService";
import DocumentModel from "../DocumentModel";

export const dataDocMixins = {
  data() {
    return {
      ExtensionService,
      aLang: LanguageService.lang,
      viewMode: "create",
      isOk: true,
      dialogComment: false,
      dialogTransfer: false,
      dialogRecall: false,
      dialogCancelSigningProcess: false,
      listRole: MethodService.getListEmployeeRoles(),
      mData: {
        moduleName: "ElectronicDocument",
        currentUser: MethodService.getCurrentUser(),
        currentCompany: MethodService.getCompanyInfo(),
        currentProfile: MethodService.getUserProfile(),
        tableRules: MethodService.copyObject(DocumentModel.tableRules),
        dataForm: MethodService.copyObject(DocumentModel.dataForm),
        validForm: DocumentModel.validForm,
        dataFormTransfer: MethodService.copyObject(DocumentModel.dataFormTransfer),
        validFormTransfer: DocumentModel.validFormTransfer,
        dataFormRecall: MethodService.copyObject(DocumentModel.dataFormRecall),
        validFormRecall: DocumentModel.validFormRecall,
        dataFormRejectSign: MethodService.copyObject(DocumentModel.dataFormRejectSign),
        validFormRejectSign: DocumentModel.validFormRejectSign,
        dataFormEditBookNumber: MethodService.copyObject(DocumentModel.dataFormEditBookNumber),
        validFormEditBookNumber: DocumentModel.validFormEditBookNumber,
        dataFormTransferToOtherCompany: MethodService.copyObject(DocumentModel.dataFormTransferToOtherCompany),
        validFormTransferToOtherCompany: DocumentModel.validFormTransferToOtherCompany,
        dataFormVTOtherCompany: MethodService.copyObject(DocumentModel.dataFormVTOtherCompany),
        validFormVTOtherCompany: DocumentModel.validFormVTOtherCompany,

        dataDefault: {
          listContractTypeId: [],
          listEmployeeInOrganizationModel: [],
          listHandleType: DataService.listHandleType,
          listCompany: [],
          listCompanySign: [],
          listDepartment: [],
          listPosition: [],
          listBranch: [],
          listDocumentType: [],
          listDocumentUrgency: [
            {
              id: 'Bình thường',
              value: 'Bình thường',
            },
            {
              id: 'Hoả Tốc',
              value: 'Hoả Tốc',
            },
            {
              id: 'Khẩn',
              value: 'Khẩn',
            },
            {
              id: 'Thượng khẩn',
              value: 'Thượng khẩn',
            },
          ],
          listDocumentSecret: [
            {
              id: 'Bình thường',
              value: 'Bình thường',
            },
            {
              id: 'Mật',
              value: 'Mật',
            },
            {
              id: 'Tuyệt mật',
              value: 'Tuyệt mật',
            },
          ],
          listDocumentOp: DataService.listDocumentOp,
          listDocumentTemplateConfigs: [],
          listDocumentTemplateCategories: [],
          listDocumentBook: [],
          listEmployee: [],
          listAllEmployee: [],
          listOrganizationModel: [],
          listTypeOrganization: [
            {
              label: "Công ty",
              value: "COMPANY",
            },
            {
              label: "Chi nhánh",
              value: "BRANCH",
            },
            {
              label: "Phòng ban",
              value: "DEPARTMENT",
            },
            {
              label: "Chức vụ",
              value: "POSITION",
            },
            {
              label: "Nhân viên",
              value: "EMPLOYEE",
            },
          ],
          listRespectivelyData: [],
          listDocumentBusiness: [],
          listOrganizationModelTree: [],

          listFileSizeOperator: MethodService.copyObject(DocumentModel.listFileSizeOperator),
          listFileSizeType: MethodService.copyObject(DocumentModel.listFileSizeType),
          listDocDuration: MethodService.copyObject(DocumentModel.listDocDuration),
          listDocContent: MethodService.copyObject(DocumentModel.listDocContent),
          listDocStatus: MethodService.copyObject(DocumentModel.listDocStatus),
          listReadStatus: MethodService.copyObject(DocumentModel.listReadStatus),
        },
        fileUploadOption: {
          fileOther: {
            limit: null,
            accept: ".pdf, .docx, .doc, .xlsx, .xls",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          fileMain: {
            limit: 1,
            accept: ".pdf, .docx, .doc, .xlsx, .xls",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          fileOther2: {
            limit: 1,
            accept: ".pdf, .docx",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          fileOther3: {
            limit: 1,
            accept: ".pdf, .docx",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
      personSelected1: "",
      personComment: "",
      textFindPeople1: "",
      listPeopleComment: [],
      listPeopleCommentTable: [],

      personSelected2: "",
      personTransfer: "",
      textFindPeople2: "",
      listPeopleTransfer: [],
      listPeopleTransferTable: [],

      departmentSelected: "",
      departmentTransfer: "",
      textFindDepartment: "",
      listDepartmentTransfer: [],
      listDepartmentTransferTable: [],
      pickerOptionFrom: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(new Date().valueOf() - 1000 * 60 * 60 * 24).getTime()
          );
        }
      },
      pickerOptionTo: {
        disabledDate(time) {
          return (
            time.getTime() > new Date(new Date().valueOf()).getTime()
          );
        }
      },
      dialogDepartmentEmployee: false,
      dataDepartmentEmployee: [],
      breadCrumb: [
        {
          name: 'Trang chủ',
          path: '/admin/hello',
        },
        {
          name: 'Văn bản điện tử',
          path: '/admin/DocumentsGeneral?tab=VanBanDen',
        },
        {
          name: '',
          path: '',
        },
      ],

      fileId: '',

      // Init data Document
      listDocumentFilter: [],
      listDocumentIn: [],
      listDocumentOut: [],
      listDocumentSign: [],
      listDocumentSignConsent: [],
      listDocumentSignTemp: [],
      listDocumentIssue: [],
      listSignRequestHistory: [],
      listTempSignRequestHistory: [],
      listTransferHistory: [],
      listPublishHistory: [],

      listNearestHistory: [],

      listPeopleFilterRaw: [],
    }
  }
}
